import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { headers, DELETE_VENDOR_WORK_ORDER, GET_VENDOR_WORK_ORDER_DETAILS, GET_VENDOR_WORK_ORDER_LIST, INSERT_UPDATE_VENDOR_WORK_ORDER, getVendorWorkOrderListUrl, insertUpdateVendorWorkOrderUrl, getVendorWorkOrderDetailsUrl, deleteVendorWorkOrderUrl, CREATE_HALL_MANAGER_ACCESS, createhallManagerAccessUrl } from "../../../../utils/constants";


export const getVendorWorkOrderList_action = (ExhibitionID, WorkOrderNumber, Services, PersonName, EmailID, Status) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
            WorkOrderNumber: WorkOrderNumber != '' ? WorkOrderNumber : null,
            Services: Services != '' ? Services : null,
            PersonName: PersonName != '' ? PersonName : null,
            EmailID: EmailID != '' ? EmailID : null,
            Status: Status != '' ? Status : null,
        }

        const res = await axiosGet(getVendorWorkOrderListUrl, params, headers)

        dispatch({
            type: GET_VENDOR_WORK_ORDER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateVendorWorkOrder_action = (WorkOrderID, ExhibitionID, VendorID, WorkOrderNumber, WorkOrderServices, PersonName, EmailID, MobileNumber, StartDate, EndDate, DeliverablesServicesList, OrganizerResponsibilitiesList, PreSetupDaysList, EventStaffSectionList, DismantlingStaffSectionList, PreSetupStaffHallMappingList, EventDayStaffHallMappingList, DismantlingStaffHallMapping, DeliverableComplianceList, PresetupStaffCountList, DismantlingStaffCountList, DocumentSectionList, IsSubmitted, PlanSubmissionDateList, IsUpdate, formType) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            WorkOrderID: WorkOrderID != '' ? parseInt(WorkOrderID) : null,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
            VendorID: VendorID != '' ? VendorID : null,
            WorkOrderNumber: WorkOrderNumber != '' ? WorkOrderNumber : null,
            WorkOrderServices: WorkOrderServices != '' ? WorkOrderServices : null,
            PersonName: PersonName != '' ? PersonName : null,
            EmailID: EmailID != '' ? EmailID : null,
            MobileNumber: MobileNumber != '' ? MobileNumber : null,
            StartDate: StartDate != '' ? StartDate : null,
            EndDate: EndDate != '' ? EndDate : null,
            DeliverablesServicesList: DeliverablesServicesList,
            OrganizerResponsibilitiesList: OrganizerResponsibilitiesList,
            PreSetupDaysList: PreSetupDaysList,
            EventStaffSectionList: EventStaffSectionList,
            DismantlingStaffSectionList: DismantlingStaffSectionList,
            PreSetupStaffHallMappingList: PreSetupStaffHallMappingList,
            EventDayStaffHallMappingList: EventDayStaffHallMappingList,
            DismantlingStaffHallMapping: DismantlingStaffHallMapping,
            DeliverableComplianceList: DeliverableComplianceList,
            DocumentSectionList: DocumentSectionList,
            PresetupStaffCountList: PresetupStaffCountList,
            DismantlingStaffCountList: DismantlingStaffCountList,
            IsSubmitted: IsSubmitted,
            PlanSubmissionDateList: PlanSubmissionDateList,
            IsUpdate: IsUpdate,
            IsHallManager: JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 7,
            FormType: formType,
        }

        const res = await axiosPost(insertUpdateVendorWorkOrderUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_VENDOR_WORK_ORDER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getVendorWorkOrderDetails_action = (WorkOrderID, ExhibitionID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            WorkOrderID: WorkOrderID != '' ? parseInt(WorkOrderID) : null,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
        }

        const res = await axiosGet(getVendorWorkOrderDetailsUrl, params, headers)

        dispatch({
            type: GET_VENDOR_WORK_ORDER_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteVendorWorkOrder_action = (WorkOrderID, ExhibitionID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            WorkOrderID: WorkOrderID != '' ? parseInt(WorkOrderID) : null,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
        }

        const res = await axiosGet(deleteVendorWorkOrderUrl, params, headers)

        dispatch({
            type: DELETE_VENDOR_WORK_ORDER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const createhallManagerAccess_action = (ExhibitionID, VendorID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: ExhibitionID != '' ? parseInt(ExhibitionID) : null,
            VendorID: VendorID != '' ? parseInt(VendorID) : null,
        }

        const res = await axiosPost(createhallManagerAccessUrl, params, headers)

        dispatch({
            type: CREATE_HALL_MANAGER_ACCESS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}